<template>
  <div>
    <vs-table :data="filterData">
      <template slot="thead">
        <vs-th>Nombre/actividad</vs-th>
        <vs-th>Grupo</vs-th>
        <vs-th>Versiones</vs-th>
        <vs-th>
          <vs-dropdown class="w-full">
            <a class="flex items-center justify-between" href.prevent>
              <div>
				  Tipo de Formulario
				  <span class="bg-success text-white rounded-lg p-1">{{filterData.length}}</span>
				</div>
              <i class="material-icons"> filter_list </i>
            </a>

            <vs-dropdown-menu>
              <vs-dropdown-item
                :class="{ 'bg-success text-white': filter === value }"
                v-for="({ value, text }, index) in filters"
                :key="index"
                @click="filter = value"
              >
                {{ text }}
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-th>
        <vs-th>Estado</vs-th>
        <vs-th>Acciones</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].activity">
            {{ data[indextr].activity }}
          </vs-td>

          <vs-td :data="data[indextr].groupName">
            {{ data[indextr].groupName }}
          </vs-td>

          <vs-td :data="data[indextr].version">
            {{ data[indextr].version }}
          </vs-td>

          <vs-td :data="data[indextr].isSubForm">
            {{ data[indextr] | typeForm }}
          </vs-td>

          <vs-td :data="data[indextr].status">
            {{ data[indextr].status }}
          </vs-td>

          <vs-td :data="data[indextr].indextr">
            <vs-button
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-repeat"
              @click="_queryForm(data[indextr].key, data[indextr])"
            ></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: ["data", "queryForm"],
  data: () => ({
    filter: null,
    filters: [
      { value: null, text: "Todos" },
      { value: 1, text: "Formulario standar" },
      { value: 2, text: "Subformulario" },
      { value: 3, text: "Multiformulario" }
    ]
  }),
  filters: {
    typeForm(data) {
      const { isMultiForms, isSubForm } = data;
      if (isMultiForms) return "Multiformulario";
      if (isSubForm) return "Subformulario";
      return "Formulario standard";
    }
  },
  computed: {
    filterData() {
      if (this.filter === null) return this.data;
      if (this.filter === 1)
        return this.data.filter(
          ({ isMultiForms, isSubForm }) => (isMultiForms === undefined || isMultiForms === false) && isSubForm === false
        );
      if (this.filter === 2)
        return this.data.filter(
          ({ isMultiForms, isSubForm }) => (isMultiForms === undefined || isMultiForms === false) && isSubForm === true
        );
      if (this.filter === 3)
        return this.data.filter(
          ({ isMultiForms, isSubForm }) => isMultiForms !== undefined && isMultiForms === true && isSubForm === false
        );
    }
  },
  methods: {
    _queryForm(key, data) {
      console.log("Key ", key);
      console.log("data ", data);
      const formType = this.typeForm(data);
      this.queryForm(key, formType)
    },
    typeForm(data) {
        const { isSubForm } = data;
        if (isSubForm) return 'subforms';
        return "standar";
    }
  }
};
</script>

<style lang="scss" scoped></style>
